import React from 'react'
import Footer from '../HomePage/Footer.js'

import { useParams } from 'react-router-dom'
import OurWorkCarousal from './OurWorkCarousal.js'
import StayConnectedSocialIcons from '../Events/StayConnectedSocialIcons.js'
import ContactusBanner from '../ContactUs/ContactusBanner.js'
import { useDispatch } from 'react-redux'
import VolunteerFormPopup from '../volunteerForm/VolunteerFormPopup.js'
const data = [
  {
    title: "Faith Aalingan Sansthan",
    para: "At Faith Aalingan Sansthan, we provide a permanent sanctuary for resilient children battling HIV+. By moving beyond temporary aid, we created a safe, secure home in collaboration with the Rajasthan Government. Here, these children find more than just shelter; they discover a community defined by absolute security, laughter, and dignity.",
    image: [
      { order: 4, url: "/images/Initiatives_3.webp" },
      { order: 3, url: "/images/Initiatives_4.webp" },
      { order: 1, url: "/images/Initiatives_1.webp" },
      { order: 2, url: "/images/Initiatives_2.webp" },

    ]
  },
  {
    title: "Humanity Welfare",
    para: 'Rooted in the spirit of "Seva" and spiritual inspiration, our Gau Shala initiative reflects our deep reverence for all living beings. We focus on providing compassionate care and a dignified environment for cattle, ensuring they are nurtured with the same dedication and kindness that defines our foundation’s core values.',
    image: [
      { order: 1, url: "/images/Initiatives_8.webp" },
      { order: 2, url: "/images/Initiatives_7.webp" },
      { order: 3, url: "/images/Initiatives_5.webp" },
      { order: 4, url: "/images/Initiatives_6.webp" },
   
    ]
  },
  {
    title: "Retinoblastoma Treatment",
    para: "We believe financial constraints should never stand between a child and their recovery. Our Retinoblastoma program ensures that children battling this severe eye cancer receive specialized medical care and life-saving treatments. We bridge the gap to high-quality healing, restoring both the health and the future potential of every child.",
    image: [
      { order: 1, url: "/images/retinoblastomaimg2.webp" },
      { order: 2, url: "/images/initiative_children_before.webp" },
      { order: 3, url: "/images/initiative_children_after.webp" },
       { order: 10, url: "/images/Initiatives_12.webp" },

    ]
  },

];

export default function OurWorkMainPage() {
  const dispatch = useDispatch();
  const { title } = useParams(); // Get the slug from /engagement/:title
  const createSlug = (text) => {
    return text
      .toLowerCase()
      .replace(/[^a-z0-9 ]/g, "")
      .replace(/\s+/g, "-");
  };
  const initiative = data.find(item => createSlug(item.title) === title);

  if (!initiative) {
    return <div className="text-center p-5">Event not found</div>;
  }
  return (
    <div>
      <VolunteerFormPopup />
      <ContactusBanner title={initiative?.title} description={initiative?.para} />

      {/* <OurWorkCarousal slides={initiative?.image} /> */}
      <OurWorkCarousal 
  key={title}
  slides={[...initiative.image].sort((a, b) => a.order - b.order)} 
/>
      {/* <StayConnectedSocialIcons /> */}
      <Footer />
    </div>
  )
}
